import React, { ReactElement } from 'react'
import Divider from '../Divider'
import MarketOverview from './MarketOverview'

const MarketPanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <MarketOverview />
        </div>
    )
}
MarketPanel.whyDidYouRender = true

export default MarketPanel
